import React, {
  useState,
  useEffect,
} from "react";
import { useNavigate } from "react-router-dom";

import {
  FormControlLabel,
  Checkbox,
  Stack,
  Button,
  Drawer,
} from "@mui/material";
import { set } from "lodash";

import { CrumbToggleScenario } from "../Components/CrumbToggles.jsx";
import { API_Client, APIs_Sweep } from "./api";
import {
  postOptions,
  getOptions,
  SweepInputUrl_get,
  empty_uuid,
  ftchPlus,
} from "./Account_urls.jsx";
import { Input_label } from "../Components/Inputs/Input_Name.jsx";
import { InputMoney } from "../Components/Inputs/Input_Money.jsx";
import { errorCheckForm, errorClear, errorJsonHasErrors, errorSet } from "../Components/Inputs/Input_Fns.jsx";
import { InputAccountsTypesNames } from "../Components/Inputs/Account_TypesNames.jsx";
import { InputSelect1, InputSelectN } from "../Components/Inputs/Select.jsx";
import { ErrorBar } from "../Components/ErrorBar.jsx";
import { Help_RunSweep } from "../Dialogs/Help/Help_Inputs.jsx";
import { GoogleAnalyticsEvent } from "../Components/ga4.jsx";
import { TopOffset } from "./Navbar_bs.jsx";

const RunSweepInput = ({ show, onClose, clientJson, c_callback }) => {
  const navigate = useNavigate();
  const [clients, setClients] = useState([]);
  const [errors, setErrors] = useState({})
  const [errmsg, setErrmsg] = useState("")
  const [doValidation, setDoValidation] = useState(0)



  const [avail, setAvail] = useState({
    AccountNames: [],
    AccountTypes: [],
    Rates: [],
    sweeps: [],
    CppMax: 70,
  });
  const [form, setForm] = useState({
    uuid: empty_uuid,
    label: "",
    AccountNames: [],
    AccountTypes: [],
    sweep: "",
    start: 0,
    finish: 0,
    increment: 1,
    keep_scenarios: false,
  });

  const onSubmit = (e) => {
    errorCheckForm()
    if (!errorJsonHasErrors(errors)) {
      postRequest();
    }
  };

  const postRequest = async () => {
    const post = {
      type: "sweep",
      sweep: {
        ScenarioUuid: clientJson.Scenario.uuid,
        account_names: form.AccountNames,
        account_types: form.AccountTypes,
        Rates: form.Rates,
        t: form.sweep,
        value_start: Number(form.start),
        value_finish: Number(form.finish),
        value_increment: Number(form.increment),
        keep_scenarios: form.keep_scenarios,
      },
    };
    GoogleAnalyticsEvent("perform", "run", "sweep", { action: "run", type: "sweep" })

    var url = API_Client + clientJson.uuid + APIs_Sweep;
    var req = postOptions;
    req.body = JSON.stringify(post);
    ftchPlus(url, req)
      .then((response) => {
        console.log(response.uuid);
        console.log(clientJson);
        let sw = {
          ...clientJson.Sweep,
          uuid: response.uuid,
          label: response.label,
        };
        let jc = { ...clientJson, Sweep: sw };

        c_callback(jc);

        /* now navigate to the grid */
        onClose();
        navigate("/sweep");
      })
      .catch((error) => {
        console.log(error.message);
        setErrmsg(error.message)
      });
  };

  const getInputData = () => {
    var url = SweepInputUrl_get(clientJson);
    ftchPlus(url, getOptions)
      .then((json) => {
        if (json) {
          setAvail({
            ...avail,
            AccountNames: json.AccountNames,
            AccountTypes: json.AccountTypes,
            Rates: json.Rates,
            sweeps: json.Sweeps,
            CppMax: json.CppMax,
          });
        }
        let cs = [];
        cs.push(clientJson.name);
        if (clientJson.spouseName !== "") {
          cs.push(clientJson.spouseName);
        }
        setClients(cs);
      })
      .catch((error) => {
        console.log(error.message);
        setErrmsg(error.message)
      });
  };

  useEffect(() => {
    if (show) {
      errorClear(errors)
      setErrmsg("")
      getInputData();
    }
  }, [show]);

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    slotProps: {
      paper: {
        sx: {
          maxHeight: ITEM_HEIGHT * 8.5 + ITEM_PADDING_TOP,
          width: 250,
        },
      },
    }
  };

  const onChange_any = (n, v) => {
    let nf = {
      ...form,
      [n]: v,
    }
    setForm(nf)
    return nf

  };

  const f_Change = (e) => {
    let value = parseInt(e.target.value);
    onChange_any(e.target.name, value);
  };

  const l_Change = (e) => {
    onChange_any(e.target.name, e.target.value);
  };
  const Change_select = (e) => {
    let nf = {
      ...form,
      [e.target.name]: e.target.value,
    }
    if (form.start < getStartMin(nf) || form.start > getStartMax(nf)) {
      nf.start = getStartMin(nf)
    }
    if (form.finish < getStopMin(nf) || form.finish > getStopMax(nf)) {
      nf.finish = getStopMax(nf)
    }

    if (form.increment < getIntervalMin(nf) || form.increment > getIntervalMax(nf)) {
      nf.increment = getIntervalDefault(nf)
    }
    //console.log(nf)
    setForm(nf)
    validate(nf)
    return nf


    //console.log(nf)
  };

  const ls_Change = (e) => {
    onChange_any(e.target.name, e.target.value[0]);
  };

  const lm_Change = (e) => {
    const value = e.target.value;
    const values = typeof value === "string" ? value.split(",") : value;
    onChange_any(e.target.name, values);
  };

  const RangeLabel = (pref) => {
    if (form.sweep === "retire" || form.sweep === "cpp" || form.sweep === "cpp & oas") {
      return pref + " Age";
    } else if (form.sweep === "expenses") {
      return pref + " Expense Value";
    }
    return pref + " Value";
  };

  const getStartMin_ = () => {
    return getStartMin(form)
  }

  const getStartMin = (f) => {
    if (f.sweep === "retire") {
      return 50;
    } else if (f.sweep === "cpp") {
      return 60;
    } else if (f.sweep === "cpp & oas") {
      return 60;
    } else if (f.sweep === "expenses") {
      return 10000;
    }
    return 1;
  };
  const getStartMax_ = () => {
    return getStartMax(form)
  }

  const getStartMax = (f) => {
    let ret = 1
    if (f.sweep === "retire") {
      ret = 70;
    } else if (f.sweep === "cpp") {
      ret = avail.CppMax - 1;
    } else if (f.sweep === "cpp & oas") {
      ret = avail.CppMax - 1;
    } else if (f.sweep === "expenses") {
      ret = 200000;
    }
    return ret;
  };

  const getStopMin_ = () => {
    return getStopMin(form)
  }
  const getStopMin = (f) => {
    let ret = 1
    if (f.sweep === "retire") {
      ret = 51;
    } else if (f.sweep === "cpp") {
      ret = 61;
    } else if (f.sweep === "cpp & oas") {
      ret = 61;
    } else if (f.sweep === "expenses") {
      ret = 20000;
    }
    const fin = Number(f.finish)
    const sta = Number(f.start)
    if (fin < sta) {
      ret = sta
    }
    return ret;
  };

  const getStopMax_ = () => {
    return getStopMax(form)
  }
  const getStopMax = (f) => {
    let ret = 1
    if (f.sweep === "retire") {
      ret = 75;
    } else if (f.sweep === "cpp") {
      ret = avail.CppMax;
    } else if (f.sweep === "cpp & oas") {
      ret = avail.CppMax;
    } else if (f.sweep === "expenses") {
      ret = 300000;
    }
    return ret;
  };

  const getIntervalMin_ = () => {
    return getIntervalMin(form)
  }

  const getIntervalMin = (f) => {
    if (f.sweep === "retire") {
      return 1;
    } else if (f.sweep === "cpp") {
      return 1;
    } else if (f.sweep === "cpp & oas") {
      return 1;
    } else if (f.sweep === "expenses") {
      return 1000;
    }
    return 1;
  };
  const getIntervalMax_ = () => {
    return getIntervalMax(form)
  }

  const getIntervalMax = (f) => {
    if (f.sweep === "retire") {
      return 10;
    } else if (f.sweep === "cpp") {
      return 5;
    } else if (f.sweep === "cpp & oas") {
      return 5;
    } else if (f.sweep === "expenses") {
      return 50000;
    }
    return 1;
  };

  const getIntervalDefault = (f) => {
    if (f.sweep === "retire") {
      return 2;
    } else if (f.sweep === "cpp") {
      return 2;
    } else if (f.sweep === "cpp & oas") {
      return 2;
    } else if (f.sweep === "expenses") {
      return 5000;
    }
    return 1;
  };



  const nt_Change = (names, types) => {

    let n = typeof names === "string" ? names.split(",") : names;
    console.log(names);
    let t = typeof names === "string" ? types.split(",") : types;
    console.log(types);
    setForm({
      ...form,
      "AccountNames": n,
      "AccountTypes": t,
    });

  };

  const validate = (f) => {
    let e = structuredClone(errors)
    let err = (f.sweep === "") ? "Please select Sweep Type" : ""
    e = set(e, "sweep", err)
    setErrors(e)
  }

  useEffect(() => {
    validate(form)
  }, [doValidation])



  return (
    <Drawer sx={{}} placement="left" open={show} onClose={onClose}>
      <Stack sx={{ mx: 6, mt: TopOffset }} spacing={2}>
        <CrumbToggleScenario
          current=""
          set={clients}
          clientJson={clientJson}
          onChange={() => { }}
          crumbClose={(json) => {
            c_callback(json);
            onClose();
          }}
        />
        <Stack sx={{ px: 2 }} spacing={2}>
          <Stack sx={{ mt: 10 }} direction="row" spacing={2}>
            <Button
              onClick={onSubmit}
              variant="contained"
              disabled={clientJson.Scenario.uuid === empty_uuid}
              sx={{ minWidth: 150, textTransform: "none", mb: 4 }}
            >
              Run Sweep
            </Button>
          </Stack>
          <Stack sx={{ pt: 2 }} spacing={2}>
            <Input_label

              disabled={clientJson.Scenario.uuid === empty_uuid}
              value={form.label}
              onChange={l_Change}
              onError={(e) => { setDoValidation(doValidation + 1); errorSet(errors, setErrors, "label", 0, e) }}
            />
            <InputSelect1
              label="Sweep Type"
              name="sweep"
              value={form.sweep}
              onChange={Change_select}
              minWidth={320}
              maxWidth={320}
              errors={errors}
              avail={avail.sweeps}
            />


            <InputAccountsTypesNames
              avail={avail}
              inputForm={form}
              onChange={nt_Change}
              MenuProps={MenuProps}
              doValidation={doValidation}
              both_allowed={true}
              onError={(e) => errorSet(errors, setErrors, "accounts", 0, e)}
            />
            <InputSelectN
              label="Rates"
              name="Rates"
              value={form.Rates}
              onChange={Change_select}
              minWidth={320}
              maxWidth={320}
              errors={errors}
              avail={avail.Rates}
              MenuProps={MenuProps}
            />


            <InputMoney
              xlabel={RangeLabel("Starting")}
              name="start"
              min={getStartMin_()}
              max={getStartMax_()}
              width={160}
              money={form.start}
              onChange={l_Change}
              required={true}
              onError={(e) => errorSet(errors, setErrors, "start", 0, e)}
            />
            <InputMoney
              xlabel={RangeLabel("Finishing")}
              name="finish"
              min={getStopMin_()}
              max={getStopMax_()}
              width={160}
              money={form.finish}
              onChange={l_Change}
              onError={(e) => errorSet(errors, setErrors, "finish", 0, e)}
            />
            <InputMoney
              xlabel="Increment"
              name="increment"
              min={getIntervalMin_()}
              max={getIntervalMax_()}
              width={160}
              money={form.increment}
              onChange={l_Change}
              onError={(e) => errorSet(errors, setErrors, "increment", 0, e)}

            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={form.keep_scenarios}
                  onChange={(e) => {
                    onChange_any("keep_scenarios", e.target.checked);
                  }}
                />
              }
              label="Keep Scenarios"
            />
          </Stack>
        </Stack>
      </Stack>
      <ErrorBar error={errmsg} />
      <Help_RunSweep />

    </Drawer >
  );
};

export default RunSweepInput;
